import React, { useEffect, useState } from "react";
import { use } from "react";
import { Layer, Rect, Transformer, Text } from "react-konva";

export default function ReportCapture(props) {
    const trRef = React.useRef();
    const shapeRef = React.useRef();

    useEffect(() => {
        if (trRef.current && props.selected) {
            trRef.current.nodes([shapeRef.current]);
            trRef.current.getLayer().batchDraw();
        }
    }, [props.selected]);

    const getDynamicFontSize = () => {
        return Math.max(1.5, 18 / props.stageScale);
    };

    const getTextPosition = () => {
        const fontOffset = getDynamicFontSize() + 0.5;

        if (!shapeRef.current) return { x: 0, y: 0 };

        const node = shapeRef.current;
        const nodeX = node.x();
        const nodeY = node.y();

        return {
            x: nodeX,
            y: nodeY - fontOffset,
        };

    };

    const handleDragEnd = (e) => {
        props.updateReportCapture(e, props.i);
    };

    const handleTransformEnd = (e) => {
        props.updateReportCapture(e, props.i);
    };

    return (
        <Layer key={props.i}>
            {props.reportCapture.name && !props.reportCapture.visible && (
                <Text
                    text={props.reportCapture.name}
                    x={getTextPosition().x}
                    y={getTextPosition().y}
                    align="center"
                    fontSize={getDynamicFontSize()}
                    fontStyle="bold"
                    fill="black"
                />
            )}

            <Rect
                ref={shapeRef}
                x={props.reportCapture.x}
                y={props.reportCapture.y}
                scaleX={props.reportCapture.scaleX}
                scaleY={props.reportCapture.scaleY}
                rotation={props.reportCapture.rotation}
                width={props.reportCapture.width}
                height={props.reportCapture.height}
                opacity={props.reportCapture.opacity}
                draggable={props.reportCapture.selected}
                listening={!props.reportCapture.locked}
                stroke={props.reportCapture.color || "lightblue"}
                strokeWidth={Math.max(0.1, 2 / props.stageScale)}
                onTap={() => props.selectReportCapture(props.reportCapture.id)}
                onClick={() => props.selectReportCapture(props.reportCapture.id)}
                onDragEnd={handleDragEnd}
            />

            {props.selected && (
                <Transformer ref={trRef} keepRatio={true} rotateEnabled={false} onTransformEnd={handleTransformEnd} />
            )}
        </Layer>
    );
}
